/**
 * @internal
 */
export enum AnimatorStatePlayState {
  UnStarted,
  Playing,
  Finished
}
